var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"template-C"},[_vm._l((_vm.data),function(item,index){return [(item.icon)?_c('img',{key:index,attrs:{"src":item.icon},on:{"click":function($event){return _vm.handleClick(item)}}}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }